import { isUndefined } from 'lodash'

export function getObjectStringList (apiName) {
  return apiName ? apiName.split('.') : []
}

export function getFieldObject (formData, list, isInit) {
  let obj = formData
  for (let i = 0; i < list.length - 1; i++) {
    if (isUndefined(obj[list[i]])) {
      isInit ? window.Vue.set(obj, list[i], {}) : obj[list[i]] = {}
    }
    obj = obj[list[i]]
  }
  return obj
}

export function checkObjectAttr (obj, list) {
  let bool = true
  let _obj = obj
  for (let i = 0; i < list.length; i++) {
    let key = list[i]
    _obj[key] ?? (bool = false)
    _obj = _obj[key]
    if (!bool) {
      break
    }
  }
  return bool
}
